import type { IComparisonSection } from '~/components/ComparisonTable.vue';
import { PlanName } from './pricing-plan-features';

export const SUPPORT_FEATURES: IComparisonSection[] = [
    {
        title: 'Support Features',
        rows: [
            {
                feature: 'Support Channel',
                text: {
                    [PlanName.Test]: 'Public Discord',
                    [PlanName.Start]: 'Private Slack/Discord',
                    [PlanName.Grow]: 'Private Slack/Discord',
                    [PlanName.Scale]: 'Private Slack/Discord',
                },
            },
            {
                feature: 'Response Time (Business Hours)',
                text: {
                    [PlanName.Test]: '<24 hr',
                    [PlanName.Start]: '<12 hr',
                    [PlanName.Grow]: '<2 hr',
                    [PlanName.Scale]: '<1 hr',
                },
            },
            {
                feature: 'Response Time (Outside Business Hours)',
                text: {
                    [PlanName.Test]: '-',
                    [PlanName.Start]: '-',
                    [PlanName.Grow]: '-',
                    [PlanName.Scale]: '<12 hr',
                },
            },
            {
                feature: 'New Integration Requests',
                text: {
                    [PlanName.Test]: 'Added to Roadmap',
                    [PlanName.Start]: 'Added to Roadmap',
                    [PlanName.Grow]: 'Prioritized',
                    [PlanName.Scale]: 'Prioritized',
                },
            },
            {
                feature: 'Quarterly Post-Launch Account Review',
                text: {
                    [PlanName.Test]: '-',
                    [PlanName.Start]: '-',
                    [PlanName.Grow]: '-',
                    [PlanName.Scale]: 'Yes',
                },
            },
            {
                feature: 'Pre-Launch Weekly Project Meetings',
                text: {
                    [PlanName.Test]: '-',
                    [PlanName.Start]: '-',
                    [PlanName.Grow]: 'Yes',
                    [PlanName.Scale]: 'Yes',
                },
            },
        ],
    },
];
